/* eslint-disable react-hooks/exhaustive-deps */
import { Formik } from "formik";

import Spinner from "../../../../../components/Spinner/index";

import InputFormik from "../../../../../components/InputFormik";
import { FormControlLabel } from "@material-ui/core";
import { SwitchBlue } from "../../../../../libs/switch";
import useFormStore from "../store/useStore";
import "./index.scss";
import { remask, unRemask } from "../../../../../libs/remask-mask";
import { convertDate, dateToInitial } from "../../../../../libs/dateUtils";
import Input from "../../../../../components/Input";
import useAuthData from "../../../../../hook/useAppData";
import { ACCESS } from "../../../../Profile/constants";

function formatarRG(rg) {

  // Remover qualquer caractere não numérico
  rg = rg.replace(/[^0-9A-Z]/gi, '');

  // Verificar se é um formato de CPF (999.999.999-AA)
  if (rg.length === 11) {
    return rg.replace(/(\d{3})(\d{3})(\d{3})([0-9A-Z]{2})/i, '$1.$2.$3-$4');
  }

  // Verificar se é o formato de RG (99.999.999-A)
  if (rg.length === 9) {
    return rg.replace(/(\d{2})(\d{3})(\d{3})([0-9A-Z]{1})/i, '$1.$2.$3-$4');
  }

  // Caso não se encaixe em nenhum dos formatos, retornar o RG original
  return rg;
}

function FormPersonalData(props: any) {
  const { accessIds } = useAuthData();
  const { updateValue, setUpdateValue, setUpdateValues } = useFormStore();
  const { modo } = useFormStore();
  const { saveOrSchedule, dateSchedule, handleSetDate } = useFormStore();
  const { needSpinner } = useFormStore();
  const { state, setState } = useFormStore();
  function handleChangePhone(event: any) {
    if (unRemask(event)?.length === 11 || unRemask(event)?.length === 10) {
      return false;
    }
    return true;
  }

  return (
    <Spinner status={needSpinner}>
      <div className="collaboratorContainer">
        <div className="title-form form-box-title">
          {modo === "create" ? (
            <h1 className="font-source-sans-pro align-self-end">Adicionar dados pessoais - {updateValue.name || "profissional"}</h1>
          ) : (
            <h1 className="font-source-sans-pro align-self-end">Atualizar dados pessoais - {updateValue.name || "profissional"}</h1>
          )}
          {saveOrSchedule == "schedule" && (
            <div className="schuduleContainer">
              <div className="calendar">
                <Input label="Data Agendamento" name="teste" placeholder="" value={dateSchedule} setValue={handleSetDate} type="date" />
              </div>
            </div>
          )}
        </div>

        <Formik initialValues={updateValue} onSubmit={() => {}}>
          {(props) => (
            <form className="form-container box-form" onSubmit={props.handleSubmit}>
              <div className="row-personal box-row">
                <InputFormik
                  className="form-input"
                  label="Nome"
                  name="name"
                  onChange={(e: any) => {
                    setUpdateValue(e.target);
                    props.handleChange(e);
                  }}
                  onBlur={props.handleBlur}
                  value={props.values.name}
                  placeholder="Digite seu nome"
                  type="text"
                  required={true}
                  autofocus={true}
                />
                <InputFormik
                  className="form-input"
                  label="Data de Nascimento"
                  name="birth_date"
                  onChange={(e: any) => {
                    setUpdateValue(e.target);
                    props.handleChange(e);
                  }}
                  onBlur={props.handleBlur}
                  value={
                    props.values.birth_date !== "" && props.values.birth_date !== null
                      ? remask(props.values.birth_date, ["99/99/9999"])
                      : props.values.birth_date
                  }
                  placeholder="Digite sua Data de Nascimento"
                  type="text"
                  required={false}
                />
              </div>
              <div className="row-personal box-row">
                <InputFormik
                  className="form-input"
                  name="email"
                  onChange={(e: any) => {
                    props.handleChange(e);
                    setUpdateValue(e.target);
                  }}
                  onBlur={props.handleBlur}
                  value={props.values.email}
                  label={`Email profissional${!accessIds.includes(ACCESS.USERS_DATA_all) ? "Bloqueado para edição" : ""}`}
                  placeholder="Digite seu email profissional"
                  type="email"
                  disabled={!accessIds.includes(ACCESS.USERS_DATA_all)}
                  required={true}
                />
                <InputFormik
                  className="form-input"
                  name="email_personal"
                  onChange={(e: any) => {
                    props.handleChange(e);
                    setUpdateValue(e.target);
                  }}
                  onBlur={props.handleBlur}
                  value={props.values.email_personal}
                  label="Email Pessoal"
                  placeholder="Digite seu email pessoal"
                  type="email"
                  required={false}
                />
              </div>
              <div className="row-personal box-row">
                <InputFormik
                  className="form-input"
                  name="CPF"
                  onChange={(e: any) => {
                    props.handleChange(e);
                    setUpdateValue(e.target);
                  }}
                  onBlur={props.handleBlur}
                  value={props.values.CPF !== "" ? remask(props.values.CPF, ["999.999.999-99"]) : props.values.CPF}
                  label="CPF"
                  placeholder="Digite seu CPF"
                  type="text"
                  required={!accessIds.includes(ACCESS.USERS_DATA_all)}
                />
                <InputFormik
                  className="form-input"
                  name="RG"
                  onChange={(e: any) => {
                    props.handleChange(e);
                    setUpdateValue(e.target);
                  }}
                  onBlur={props.handleBlur}
                  value={
                    props.values.RG !== "" && props.values.RG !== null ? formatarRG(props.values.RG?.toUpperCase()) : props.values.RG
                  }
                  label="RG"
                  placeholder="Digite seu RG"
                  type="text"
                  required={!accessIds.includes(ACCESS.USERS_DATA_all)}
                />
              </div>
              <div className="row-personal box-row ">
                <InputFormik
                  className="form-input"
                  name="phone"
                  onChange={(e: any) => {
                    handleChangePhone(e.target.value);
                    props.handleChange(e);
                    setUpdateValue(e.target);
                  }}
                  onBlur={props.handleBlur}
                  value={remask(props.values.phone, [`${unRemask(String(props.values.phone))?.length < 11 ? "(99) 9999-9999" : "(99) 9 9999-9999"}`])}
                  label="Telefone 1"
                  placeholder="Digite seu telefone"
                  type="text"
                  maxlength="16"
                  required={!accessIds.includes(ACCESS.USERS_DATA_all)}
                />
                <InputFormik
                  className="form-input"
                  name="phone_two"
                  onChange={(e: any) => {
                    handleChangePhone(e.target.value);
                    props.handleChange(e);
                    setUpdateValue(e.target);
                  }}
                  onBlur={props.handleBlur}
                  value={
                    props.values.phone_two !== null && props.values.phone_two !== ""
                      ? remask(props.values.phone_two, [
                          `${unRemask(String(props.values.phone_two))?.length < 11 ? "(99) 9999-9999" : "(99) 9 9999-9999"}`,
                        ])
                      : props.values.phone_two
                  }
                  label="Telefone 2"
                  placeholder="Digite seu telefone Secundário (Opcional)"
                  type="text"
                  maxlength="16"
                  required={false}
                />
              </div>

              {accessIds.includes(ACCESS.USERS_DATA_all) && modo === "update" && (
                <>
                  <div className="row-personal box-row ">
                    <div className="row box-row form-input switch">
                      <FormControlLabel
                        className=""
                        labelPlacement="start"
                        label="Estado do Profissional"
                        control={
                          <SwitchBlue
                            checked={!state}
                            onChange={() => {
                              setState(!state);
                              if (!state && !!updateValue.end_date === false)
                                return setUpdateValues({ ...updateValue, end_date: convertDate(dateToInitial) });
                              if (state && !!updateValue.end_date) return setUpdateValues({ ...updateValue, end_date: "" });
                            }}
                            name="isDeleted"
                            color="primary"
                          />
                        }
                      />
                    </div>
                  </div>
                </>
              )}
            </form>
          )}
        </Formik>
      </div>
    </Spinner>
  );
}

export default FormPersonalData;
